<template>
  <component :is="list.skipCardLayout?'div':'md-card'">
      <div class="dynamicList-loading"
           v-show="isPromisePending">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>

      <md-field>
      <md-autocomplete v-model="caseSearchTerm" :md-open-on-focus="true"
          :md-options="casesList" 
          @md-changed="getCases" 
          @md-opened="getCases"
          @md-selected="selectCase"
      >
        <label>Destination Case</label>
        <template slot="md-autocomplete-item" slot-scope="{ item }">{{ item.subject }}</template>
      </md-autocomplete>

      </md-field>
      <div class="md-card-actions md-alignment-space-between">
        <div></div>
        <div>
          <md-button class="md-button btn-next md-success md-theme-default" @click="runMergeCase()" :disabled="isDisabled">Merge Case</md-button>
          <md-button class="md-theme-default" @click="onDialogClose">Close</md-button>
        </div>
      </div>
  </component>
</template>

<script>
  import { Pagination } from "@/components";
  import Fuse from "fuse.js";
  import Swal from "sweetalert2";

  import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
  import * as queries from '@/graphql/queries';
  import * as queries_custom from '@/graphql/queries_custom';
  import * as mutations from '@/graphql/mutations';
  import * as subscriptions from '@/graphql/subscriptions';
  import searchConfig from '@/searchConfig';
  import gql from "graphql-tag";

  export default {
    props: {
      list: {
        type: Object,
        required: true
      },
      filter: {
        type: Object
      },
      params: {
        type: Object
      }
    },
    components: {
      Pagination
    },
    data() {
      return {
        isPromisePending: false,
        selectedCase: null,
        caseSearchTerm: "",
        isDisabled: true,
        searchConfig: searchConfig,
        lazyLoadSearchableFields: ['subject'],   
        lazyLoadFilter: {
          bool: {
              must_not: [{match: { id: this.$route.params.id }}, {match: { status: 'Merged' }}]
          }
        },
        casesList: [],
      };
      
    },
    apollo: {
      subscriptions: {
        query: function() {
          return gql(queries['searchUsers']);
        },
        variables: {
          filter: { id: { eq: '-1' } },
          limit: 1,
        },
        update: () => [],
      }
    },
    watch: {
      'selectedCase': {
        immediate: true,
        handler: function(){
          if(this.selectedCase || this.selectedCase != "") {
            this.isDisabled = false;
          }
        }
      }
    },
    
    methods: {
      enablePageScroll() {
        const body = document.querySelector('body');
        body.classList.remove('isCaseDialogOpen');
      },

      onDialogClose() {
        this.list.showRelatedDialog = false;

        //remove class on body when case dialog is closed
        this.enablePageScroll();
      },
      async runMergeCase(){
        const caseItem = this.selectedCase;
        //build the name first
        let nameFields = this.list.mergeMessageNameFields ? this.list.mergeMessageNameFields : ['name'];
        let objectName = '';
        nameFields.forEach((nf, index) => {
          objectName += caseItem[nf];
          if (index !== nameFields.length -1) objectName += ' ';
        });

        let title = this.list.mergeMessageTitle;
        title = title.replace('{objectName}', objectName);
        title = title.replace('{sourceCase}', this.list.sourceCaseSubject);

        //this text is different because we want to allow config of '' to omit the default text
        let text = typeof this.list.mergeMessageText !== 'undefined' ? this.list.mergeMessageText : `The change cannot be undone.`;

        Swal.fire({
          title: title,
          text: text,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes",
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
              this.updateCaseData(caseItem);
          }
        });
      },

      updateCaseData(item){
        //update data in Message model
        const sourceMsg = this.list.sourceCaseMessagesList;
        sourceMsg.forEach((el, idx) => {
          let input = {};
          input['id'] = el.id;
          input['messageCaseId'] = item.id;
          
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          input['messageUpdatedById'] = this.$reduce(this, '$Session.userId');

          this.updateAction(this.list.updateMessageMutationId, input);
        });

        //update data in Note model
        const sourceNotes = this.list.sourceCaseNotesList;
        sourceNotes.forEach((el, idx) => {
          let input = {};
          input['id'] = el.id;
          input['noteCaseId'] = item.id;
          
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          input['noteUpdatedById'] = this.$reduce(this, '$Session.userId');

          this.updateAction(this.list.updateNoteMutationId, input);
        });

        //update status in source case
        let caseInput = {};
        caseInput['id'] = this.list.sourceCaseId;
        caseInput['status'] = this.list.mergeCaseStatus;
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        caseInput['caseUpdatedById'] = this.$reduce(this, '$Session.userId');
        
        this.updateAction(this.list.updateCaseMutationId, caseInput);

        this.list.showRelatedDialog = false;
        this.afterUpdateAction(item);
      },

      async updateAction(mutationId, updateInput) {
        await API.graphql(graphqlOperation(mutations[mutationId], {input: updateInput}))
          .then(result => {
            this.$c.log(mutationId + " result: ", result);
          })
          .catch(error => {
            this.$c.log(this.list.pageTitle + " updating record error:", error);
          });
      },

      afterUpdateAction(item) {
        Swal.fire({
          title: "Case Merged!",
          text: `You merged ${this.list.sourceCaseSubject} into ${item.subject}`,
          confirmButtonClass: "md-button md-success btn-fill",
          buttonsStyling: false
        }).then(result => {
          setTimeout(() =>{
            //remove class on body when case is merged
            this.enablePageScroll();
            this.$router.push({ path: "/" + this.list.editPath + "/" + item.id});
          }, 400);
        });
      },
    
      async search(searchString, useNextToken) {
        const listQueryId = this.list.listQueryId;
        //this.$c.log(listQueryId + " search(" + searchString + ")");

        const searchMethod = listQueryId.substring(0, 6) === 'search'? 'wildcard' : 'contains';
        let params = {
          "limit": this.list.pagination.perPage
        };

        if (useNextToken && this.list.nextToken) {
          params.nextToken = this.list.nextToken;
        }

        let filters = [], operation;

        //if (typeof searchString !== 'undefined' && searchString !== "" && this.list.searchFields) {
        if (typeof searchString !== 'undefined' && searchString !== "") {
          let searchConfig = this.getSearchConfig();

          searchConfig.searchFields.forEach((searchField) => {
            let test = {};
            test[searchField] = {};//{contains: searchString};
            test[searchField][searchMethod] = '*' + searchString + '*';
            filters.push(test);
          });
        }
        this.$c.log(listQueryId + " search(" + searchString + ") filters: ", filters);

        if (typeof this.filter !== 'undefined') {
          //filters.push(this.list.filter);
          if (filters.length > 1) {
            params.filter = {and: [
                this.filter,
                {or: filters}
              ]};
          } else if (filters.length === 1) {
            params.filter ={and: [
                this.filter,
                filters[0]
              ]};
          } else {
            params.filter = this.filter;
          }
        } else {
          if (filters.length > 1) {
            params.filter = {or: filters};
          } else if (filters.length === 1) {
            params.filter = filters[0];
          }
        }

        if (typeof this.params !== 'undefined') {
          this.$loopo(this.params, (param, paramName) => {
            params[paramName] = param;
          });
        }

        this.$c.log(listQueryId + " search(" + searchString + ") params: ", params);

        //Get the correct query
        let query = queries[listQueryId];
        if (typeof query === 'undefined') {
          query = queries_custom[listQueryId];
        }


        operation = graphqlOperation(query, params);

        this.$c.log(listQueryId + " search(" + searchString + ") operation: ", operation);

        this.isPromisePending = true;

        const result = await API.graphql(operation);
        this.$c.log(listQueryId + " search(" + searchString + ") Results Raw:", result.data);
        let response = false;

        if (result.data && result.data[listQueryId]) {
          let data = result.data[listQueryId];
          this.$c.log('oldNextToken: [' + this.list.nextToken + ']');
          this.$c.log('newNextToken: [' + data.nextToken + ']');

          if (data.nextToken !== this.list.nextToken) {
            this.list.nextToken = data.nextToken;
          } else {
            this.list.nextToken = false;
          }
          if (typeof this.list.formatResponse === 'function') {
            response = this.list.formatResponse(result.data);
          } else if (data.items) {
            response = data.items;
          }
        }
        this.$c.log(listQueryId + " search(" + searchString + ") Results Formatted:", response);
        this.isPromisePending = false;
        return response;
      },

    getElasticSearchFilter(searchTerm) {
      const columnFilters = this.lazyLoadSearchableFields.map(_fieldName => ({
        query_string: {
          default_field: _fieldName,
          query: `*${searchTerm}*`,
        },
      }));
      //add filter passed from list config
      let _filter = null;
      if (this.lazyLoadFilter) {
        _filter = this.lazyLoadFilter;
      }
      const filter = {
        bool: {
          should: columnFilters,
          minimum_should_match: 1,
        }
      };
      if (_filter) {
        filter.bool.filter = _filter;
      }
      return { esQuery: JSON.stringify(filter) };
    },

    selectCase (c){
      this.selectedCase = c;
      this.caseSearchTerm = c.subject;    
    },

    getCases (searchTerm) {
      this.casesList = new Promise(resolve => {       
          if (!searchTerm) {
            return resolve(this.casesList)                        
          } else {
            const term = searchTerm.trim()
          clearTimeout(this.timeoutId)
          this.timeoutId = setTimeout(() => {            
            const listQueryId = 'searchCases';
            let query = queries[listQueryId];
            if (typeof query === 'undefined') {
              query = queries_custom[listQueryId];
            }
            
            // graphql operation
            const operation = graphqlOperation(query, {
              filter: this.getElasticSearchFilter(term),
              limit: 49,
            });
            
            // call API
            API.graphql(operation)
              .then(res => {
                // get items
                const items = this.$reduce(res, `data.searchCases.items`);                                      
                  this.casesList = items;
                  return resolve(this.casesList)    
              })
              .catch(err => {
                return new Promise(resolve => resolve([]));
              });
          }, 250);
          }        
      })
    }
    },
    // async mounted() {
    //   //added condition to skip the API call
    //   if (this.list.isApiDisabled) {
    //     return;
    //   }

    //   if (this.list.tableData.length === 0 || this.list.forceMountedRefresh) {
    //     const result = await this.search();
    //     this.list.tableData = result;

    //     // Fuse search initialization.
    //     this.list.fuseSearch = new Fuse(this.list.tableData, {
    //       keys: this.sortableColumnNames,
    //       threshold: 0.3
    //     });

    //     this.$c.log(this.list.listQueryId + " mounted() this.list.tableData:", this.list.tableData);
    //   }

    //   if (this.list.subscriptions) {
    //     this.$loopo(this.list.subscriptions, (sub, name) => {
    //       this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);

    //       if (typeof subscriptions[name] === 'undefined') {
    //         this.$c.error('SUBSCRIPTION [' + name + '] not found!');
    //         return;
    //       }

    //       let thisFunc = this.list.subscriptions[name].function;
    //       this.$apollo.queries.subscriptions.subscribeToMore({
    //         document: gql(subscriptions[name]),
    //         updateQuery: (previousResult, { subscriptionData }) => {
    //           console.log('SUBSCRIPTION ', name, subscriptionData);
    //           thisFunc({ value: subscriptionData });
    //         },
    //       });
    //     });
    //   }
    // },
  };
</script>

<style lang="css">
.md-list-item-content span.md-list-item-text {
  display: inline-block !important;
  text-overflow: ellipsis !important;
}
.md-menu-content.md-select-menu {
  min-width: 40%;
}
.md-select-menu.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default.md-menu-content-leave-active.md-menu-content-leave-to._dynamic-options-select,
.md-select-menu.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default._dynamic-options-select {
  min-width: 280px !important;
  width: 280px !important;
  max-width: 280px !important;
}
</style>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }

  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }

  button.md-button.md-button.btn-next.md-success.md-theme-default.md-theme-default,
  button.md-button.md-theme-default.md-theme-default {
    min-width: 25%;
    margin: 40px 8px 0px 5px;
  }
  .md-field.md-theme-default {
    width: 70%;
    margin: 10px 0px 10px 15px;
  }
</style>
